export default {
  scorecard: {
    title: 'スコアカード',
    content: '内容',
    award: 'ESGアワード',
  },
  list_table_filter: {
    table_buyer_company_name: '評価依頼企業',
    table_question_group_name: '調査票',
    table_status: 'ステータス',
    table_issue_at: '発行日',
    table_sustaina_rate: 'ESGレーティング',
    table_esg_score: 'ESGスコア',
    table_operation: '操作',
    number_of_suppliers: '被評価企業数',
    displayed_items_number: '{total}件中{start}〜{end}件の表示',
    displayed_items_number_empty: '0件中0件の表示',
    no_data_display: 'データが見つかりませんでした。',
    csv_modal_title: 'CSV出力内容を選択してください',
    csv_modal_answer_status_title: '回答状況',
    csv_modal_answer_status_text: '被評価企業の回答状況を一覧で出力します。',
    csv_modal_answer_title: '回答（500社1ファイルずつ）',
    csv_modal_answer_title_by_individual_company: '回答（1社1ファイルずつ）',
    csv_modal_answer_text: '被評価企業の回答内容を500社1ファイル形式で出力します。',
    csv_modal_answer_text_by_individual_company: '被評価企業の回答内容を1社1ファイル形式で出力します。',
    csv_modal_score_title: 'スコア',
    csv_modal_score_text: '被評価企業のレーティングとスコアを一覧で出力します。',
    csv_modal_answer_heading: '見出し行',
    csv_modal_answer_heading_supplier: '被評価企業',
    csv_modal_answer_heading_question: '設問',
    csv_modal_answer_additional: '追加項目',
    csv_modal_answer_additional_note: '備考',
    csv_modal_answer_additional_file: '添付ファイル名',
    csv_modal_cautionary_note_title: 'ご注意',
    csv_modal_cautionary_note_content: '・{questionGroupName}の回答状況、回答、スコアが出力対象です。\n・回答状況について、調査票/サーベイの回答ステータスに関わらず全ての被評価企業が対象です。\n・回答、スコアについて、調査票/サーベイの回答ステータスが「未回答」の被評価企業は対象外です。\n・回答、スコアについて、1つのCSVファイルに表示される社数の上限は500社です。\n・集計された回答、スコアのCSVファイルは、ログイン中のアカウントのメールアドレスへ送信されます。',
    csv_modal_sent_mail_section_one: 'CSV出力リクエストを受け付けました。',
    csv_modal_sent_mail_section_two: 'メールアドレスへCSVダウンロードURLを送信しますので、しばらくお待ちください。',
    csv_modal_sent_mail_section_three: '30分経ってもメールが来なければ、再度お試しください。',
  },
  overall_score_section: {
    card_title: '調査内容',
    score: 'スコア',
    esg_score: 'ESGスコア',
    esg_rating: 'ESGレーティング',
    esg_score_tip: 'ESGスコアとは、貴社のESGへの取組みに対する評価をスコア化した数値です。ASUENE ESGの調査票/サーベイへの回答内容をもとに算出されます。',
    esg_rating_tip: 'ESGレーティングとは、貴社のESGの取組みレベルを絶対評価で表したものです。ESGスコアに基づいてAAA〜CCCの7段階で分類されます。',
    evaluator_advice_title: '評価コメント',
    list_header_buyer_company_name: '評価依頼企業',
    list_header_supplier_company_name: '被評価企業',
    list_header_question: '@:common.upload.title',
    list_header_create_at: '発行日',
    list_header_deadline: '有効期限',
    list_header_industry: '業種',
    list_header_company_scale: '従業員数',
    download_csv: 'CSV出力',
    download_pdf: 'PDF出力',
    csv_title_for_buyer: 'アスエネESG_調査票回答',
    csv_title_for_supplier: 'アスエネESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: 'CSVで回答がダウンロードされます',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: 'PDFで回答がダウンロードされます',
    scorecard_pdf: 'スコアカード(PDF)',
    download_scorecard_pdf_description: 'PDFでスコアがダウンロードされます',
    feedback: '評価フィードバック',
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: 'PDFで資料がダウンロードされます',
    award_medal_svg: 'ESGアワード(SVG)',
    download_award_medal_svg_description: 'SVG画像がダウンロードされます',
    award_medal_png: 'ESGアワード(PNG)',
    download_award_medal_png_description: 'PNG画像がダウンロードされます',
    pdf_modal_sent_mail_section_one: 'PDF出力リクエストを受け付けました。',
    pdf_modal_sent_mail_section_two: 'メールアドレスへPDFダウンロードURLを送信しますので、しばらくお待ちください。',
    pdf_modal_sent_mail_section_three: '30分経ってもメールが来なければ、再度お試しください。',
  },
  category_score_section: {
    card_title: 'カテゴリ別スコア',
    tip: 'カテゴリ別スコアとは、貴社の環境、社会、ガバナンスごとのスコアです。回答される企業様によって各カテゴリの設問の重みづけは異なります。',
    policy: '規範・方針',
    action: '施策',
    result: '結果',
  },
  score_by_category_compared_section: {
    card_title: 'カテゴリ別スコア比較',
    get_score_by_category: '獲得したカテゴリ別スコア',
    esg_evaluated_all_companies_average: 'アスエネESGが評価した全ての企業平均',
    tip: '同じ調査票/サーベイに回答した企業の平均スコアです。現時点の平均値のため、数字は変動する可能性があります。',
  },
  strengths_advice_section: {
    card_title: '評価点・改善点',
    strong_point: '評価点',
    advice: '改善点',
    policies: '規範・方針',
    action: '施策',
    result: '結果',
    no_results_for_this_category: 'このカテゴリに関して表示できる結果はありません。',
    risk: 'リスク度',
    indicator: '指標',
    content: '内容',
    operation: '操作',
    item: '@:improvementplans.unit',
    no_data_display: '該当するデータは登録されていません。',
  },
  preview: {
    go_back_to_scorecard: 'スコアカードに戻る',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: '全体スコア概要',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: '平均',
    category_card_score_no_score: '対象外',
    category_card_score_earned_score: '獲得したスコア',
    category_card_details_list_title: '評価コメント',
    category_card_details_no_score_tip: '本カテゴリは評価対象外です。',
    category_card_score_average_score: '他社の平均点',
    category_card_details_title: 'カテゴリ別スコア概要',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: '評価依頼企業が定める評価ロジックで採点しているため、評価対象外の項目です。',
    buyer_evaluate_tip: '評価依頼企業が定める評価ロジックで採点しています。アスエネESGの評価ロジックでは採点しておりません。',
    answer_rejection_notification: '企業から取り下げ依頼がありました',
    answer_rejection_modal_title: '回答を差し戻す',
    answer_rejection_modal_text: '差し戻しコメント',
    answer_rejection_modal_content: '{companyName}の回答を差し戻します。\n担当者への差し戻しコメントを下記に記載し、送信してください。',
    answer_rejection_dialog_content: '{companyName}の回答を差し戻しました。',
    answer_rejection_button_title: '差し戻し',
  },
}
